import {Component, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-inactive-subscription-page",
    imports: [],
    templateUrl: "./inactive-subscription-page.component.html",
    styleUrl: "./inactive-subscription-page.component.scss",
})
export class InactiveSubscriptionPageComponent {}
